class Loader {
    constructor(wrapper) {
        this.wrapper = wrapper;

        if (this.wrapper.children('.' + this.getLoaderClass()).length == 0)
            this.wrapper.append(this.getHTML());
        this.loader = this.wrapper.children('.' + this.getLoaderClass());

        return this;
    }

    getHTML() {
        var html = '<div class="' + this.getLoaderClass() + '">' +
            '<div class="ball-pulse">' +
                '<div></div>' +
                '<div></div>' +
                '<div></div>' +
            '</div>' +
        '</div>';

        return html;
    }

    getLoaderClass() {
        return 'loading';
    }

    start() {
        this.loader.show();
    }

    pause() {
        this.loader.hide();
    }

    stop() {
        this.pause();
        this.clear();
    }

    clear() {
        this.loader.remove()
    }

}

export default Loader;